/* eslint-disable react/no-multi-comp */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useTranslation } from 'react-i18next';

interface Props {
  color?: string;
  title?: string;
  numbers: string;
  icon?: IconProp;
}

const Basic: React.FC<Props> = ({ color = '', title = '', numbers, icon }) => {
  const { t } = useTranslation();

  return (
    <div className={`notification notification--${color} d-flex`}>
      <div className="notification__content w-100">
        {icon && (
          <div className="notification__icon">
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
        <h5 className="notification__title bold-text">{title}</h5>
        {numbers && (
          <>
            <p className="notification__message">{t('deleteThiDocRelatedWarning')}</p>
            <p className="notification__message">{numbers.concat('.')}</p>
            <p className="notification__message">{t('deleteThiDocIfRelatedWarning')}</p>
          </>
        )}
      </div>
    </div>
  );
};
export default React.memo(Basic);
export const RelatedNotification = React.memo(Basic);
